import React from 'react';
import cx from 'classnames';
import { LinkV2 } from '@zola/zola-ui/src/components/LinkV2';
import { ImageFieldType } from 'libs/contentful/types';

import { DESKTOP_MIN, TABLET_MIN } from 'libs/universal/utils/device';
import styles from './HeroSection.module.less';
import ContentfulResponsivePicture from '../ContentfulResponsivePicture';

type HeroSectionProps = {
  title: string;
  excerpt: string;
  author?: string;
  heroImage?: ImageFieldType;
  heroCredit?: string;
  heroCreditUrl?: string | ImageFieldType;
  tldr?: string;
};
const HeroSection: React.FC<HeroSectionProps> = ({
  title,
  excerpt,
  author,
  heroImage,
  heroCredit,
  heroCreditUrl,
  tldr,
}) => {
  return (
    <header className={cx(styles.hero, { [styles.borderBottom]: !tldr })}>
      <div className={styles.heroCopyContainer}>
        <h1 className={styles.title}>{title}</h1>
        <p className={styles.pageExcerpt}>{excerpt}</p>
        {author && <p className={styles.author}>By {author}</p>}
      </div>
      <div className={styles.heroImageContainer}>
        {heroImage && heroImage.src && (
          <ContentfulResponsivePicture
            src={heroImage.src}
            alt={heroImage.altText}
            breakpointWidthMap={{ [TABLET_MIN]: 929, [DESKTOP_MIN]: 635 }}
          />
        )}
        {heroCredit && (
          <div className={styles.heroCredit}>
            Photo by{' '}
            {heroCreditUrl ? (
              <LinkV2
                variant="secondary"
                href={typeof heroCreditUrl === 'string' ? heroCreditUrl : ''}
              >
                {heroCredit}
              </LinkV2>
            ) : (
              <span>{heroCredit}</span>
            )}
          </div>
        )}
      </div>
    </header>
  );
};

export default HeroSection;
